import React, { Component } from "react";
import { TextField, Button, Grid, Box, CircularProgress, Paper, Typography } from "@mui/material";
import History from "../../utils/history";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMailBulk } from "@fortawesome/free-solid-svg-icons";
import { API_URL } from "../../config";

class Feedback extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = { subject: "", feedback: "", thanks: "", submitting: false };
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleFeedback = (e) => {
    if (this._isMounted) this.setState({ feedback: e.target.value });
  };

  handleSubject = (e) => {
    if (this._isMounted) this.setState({ subject: e.target.value });
  };

  submitForm = async (e) => {
    e.preventDefault();
    const token = this.props.token;

    if (this.state.subject === "" || this.state.feedback === "") {
      alert("Incomplete details!");
    } else {
      this.setState({ submitting: true });

      try {
        const body = JSON.stringify({
          subject: this.state.subject,
          feedback: this.state.feedback,
        });

        const response = await fetch(
          API_URL + "/users/v1/feedback",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: body,
            method: "POST",
          }
        );

        const responseData = await response;

        if (responseData.status === 200) {
          this.setState({ thanks: "Thanks for your feedback!" });
        } else {
          //alert("feedback send error " + responseData.status);
          toast.warn("Something went wrong: Error " + responseData.status);
          this.setState({ submitting: false });
        }
      } catch (err) {
        toast.warn("Something went wrong: Syntax Error.");
      }
    }
  };

  render() {
    return (
      <Box sx={{ mt: 5, pt: 5, mx: 'auto', width: '100%', px: 3 }}>
        <Box sx={{ maxWidth: 'md', mx: 'auto', textAlign: 'left' }}>
          <Paper elevation={3} sx={{ borderRadius: '1.5rem', overflow: 'hidden' }}>
            <Grid container>
              <Grid item md={3} sx={{ display: { xs: 'none', md: 'flex' }, bgcolor: 'primary.main', color: 'white', alignItems: 'center', justifyContent: 'center', p: 2 }}>
                <FontAwesomeIcon
                  icon={faMailBulk}
                  style={{ fontSize: "60px" }}
                />
              </Grid>
              <Grid item xs={12} md={9} sx={{ p: 3, bgcolor: 'background.paper' }}>
                <Typography variant="h4" component="h2" className="futura" sx={{ mt: 2 }}>Send Feedback</Typography>
                {this.state.thanks ? (
                  <div>
                    <Typography variant="h6" sx={{ mb: 5 }}>Thanks for your feedback!</Typography>
                    <Button
                      variant="contained"
                      sx={{ borderRadius: '30px', px: 3 }}
                      onClick={History.goBack}
                    >
                      Go Back
                    </Button>
                  </div>
                ) : (
                  <Box component="form" onSubmit={this.submitForm}>
                    <Box sx={{ p: 3,  borderRadius: 1 }}>
                      <TextField
                        label="Subject"
                        fullWidth
                        onChange={this.handleSubject}
                        className="mb-3"
                        required
                        variant="filled"
                      />
                      <TextField
                        label="Tell us what you think"
                        multiline
                        rows={5}
                        fullWidth
                        onChange={this.handleFeedback}
                        required
                        sx={{ mt: 2 }}
                        variant="filled"
                      />
                    </Box>
                    <Box sx={{ textAlign: 'center' }}>
                      <Button
                        type="submit"
                        variant="contained"
                        disabled={this.state.submitting}
                        sx={{ borderRadius: '30px', px: 3 }}
                      >
                        {this.state.submitting ? (
                          <CircularProgress
                            size={24}
                            sx={{ color: 'white' }}
                          />
                        ) : (
                          "Submit"
                        )}
                      </Button>
                    </Box>
                  </Box>
                )}
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </Box>
    );
  }
}

export default Feedback;
